import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPencilSquare = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18 1.93945L22.0607 6.00011L12.0607 16.0001H8V11.9395L18 1.93945ZM9.5 12.5608V14.5001H11.4393L19.9393 6.00011L18 4.06077L9.5 12.5608ZM3 3.00011H12V4.50011H4.5V19.5001H19.5V12.0001H21V21.0001H3V3.00011Z",
		fill: "currentColor"
	})]
});
export default SvgPencilSquare;
